import React from 'react'
import { Container, Button, Alert } from 'react-bootstrap';
import Document from './Document/Document';
import { useTranslation } from 'react-i18next';
import { FadeLoader } from 'react-spinners';
import "./DocumentsList.css"

const DocumentsList = ({ contents, isLoading, getMoreAssets, next }) => {
    const { t } = useTranslation();

    return (
        <Container fluid className='panel panel-body d-flex flex-column align-items-center justify-content-center documents-list'>
            {!isLoading ? (
                <>
                    {contents?.map((document) => {
                        return (
                            <Document key={document.globalAssetId} documentContent={document}></Document>
                        );
                    })}
                    {next && <Button variant="outline-secondary" className='more-btn w-100' onClick={getMoreAssets}>{t('more')}</Button>}
                    {contents.length === 0 && <Alert variant="info" className="w-100 h-100">{t('no_results')}</Alert>}
                </>
            ) : (
                <Container fluid style={{ "height": "120px" }} className="d-flex justify-content-center">
                    <FadeLoader
                        color="#1a6fb8"
                        height={25}
                        loading
                        margin={15}
                        radius={2}
                        speedMultiplier={1.5}
                        width={3}
                    />
                </Container>
            )}
        </Container>
    );
};

export default DocumentsList